import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { ENoticeType } from 'src/enums';
import { getMonthByNumber } from '../../helpers';
import { ReactComponent as CloseIcon } from '../../icons/Close.svg';
import { deleteNotice, TNotice } from '../../redux/noticesSlice';
import { CustomTypography } from '../custom/CustomTypography';
import styles from './Notice.module.css';

interface INoticeProps {
  notice: TNotice;
}

export const Notice: FC<INoticeProps> = ({ notice }) => {
  const { id, type, isRead, message, timestamp } = notice;
  const getTime = () => {
    const timestampDate = new Date(timestamp);
    const time = `${String(timestampDate.getHours()).padStart(2, '0')}:${String(
      timestampDate.getMinutes(),
    ).padStart(2, '0')}`;
    const timestampDay = timestampDate.getDate();
    const currentDay = new Date().getDate();

    if (timestampDay == currentDay) {
      return (
        <CustomTypography className={clsx('text-14')} color="grey">
          {time}
        </CustomTypography>
      );
    } else {
      return (
        <CustomTypography className={clsx('text-14')} color="grey">
          {`${timestampDay} ${getMonthByNumber(timestampDate.getMonth())} в ${time}`}
        </CustomTypography>
      );
    }
  };
  const dispatch = useDispatch();
  const removeNotice = (id: number) => dispatch(deleteNotice(id));

  return (
    <Box className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.icons}>
          <div className={styles['circle-wrapper']}>
            {!isRead && <div className={styles.circle}></div>}
          </div>
          {type === ENoticeType.error && (
            <CancelOutlinedIcon className={clsx(styles.icon, styles.iconError)} />
          )}
          {type === ENoticeType.warning && (
            <ReportProblemOutlinedIcon className={clsx(styles.icon, styles.iconWarning)} />
          )}
          {type === ENoticeType.info && (
            <InfoOutlinedIcon className={clsx(styles.icon, styles.iconInfo)} />
          )}
        </div>
        <div className={styles['message-wrapper']}>
          <CustomTypography
            color={isRead ? 'grey' : undefined}
            className={clsx('text-14', styles.message)}
          >
            {message}
          </CustomTypography>
          {timestamp && getTime()}
        </div>
        <div className={styles['button-wrapper']}>
          <IconButton
            sx={(theme) => ({
              '& path': {
                stroke: theme.palette.custom.main,
              },
            })}
            className={clsx(styles['close-button_show'])}
            onClick={() => removeNotice(id)}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>
    </Box>
  );
};
